import React, { FC } from 'react'
import Svg, { Circle, Path, SvgProps } from 'react-native-svg'

// Guild brand icon — subtle outer circle with the Guild logo shapes inside.
// Outer circle: semi-transparent fill to match the subtracted PNG appearance.
// Inner shapes: from guild-icon-white.svg, re-centered to a 64x64 viewBox.
const GuildLogo: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 64 64' {...props}>
    <Circle cx={32} cy={32} r={32} fill={fillColor} opacity={0.12} />
    <Path
      d='M13.396 32C13.396 41.0233 19.822 48.547 28.3467 50.2475C29.0834 50.3926 29.7681 49.8308 29.7681 49.0791V14.9247C29.7681 14.1731 29.0834 13.6112 28.3467 13.7563C19.822 15.4531 13.396 22.9768 13.396 32Z'
      fill={fillColor}
    />
    <Path
      d='M42.0466 30.1397C46.5677 30.1397 50.2327 26.4747 50.2327 21.9536C50.2327 17.4326 46.5677 13.7676 42.0466 13.7676C37.5256 13.7676 33.8606 17.4326 33.8606 21.9536C33.8606 26.4747 37.5256 30.1397 42.0466 30.1397Z'
      fill={fillColor}
    />
    <Path
      d='M34.2332 35.7212V49.1612C34.2332 49.8644 34.8732 50.3965 35.5615 50.2626C42.9811 48.8226 48.8266 42.9807 50.2629 35.5612C50.3969 34.8728 49.8648 34.2328 49.1615 34.2328H35.7215C34.8992 34.2328 34.2332 34.8988 34.2332 35.7212Z'
      fill={fillColor}
    />
  </Svg>
)
export default GuildLogo
